export enum PvzOperation {
  /** Приём отправлений. */
  Acceptance = 1,
  /** Выдача отправлений. */
  Issuance = 2,
  /** Приём и выдача. */
  AcceptanceAndIssuance = 3
}

export enum PvzType {
  /** Пункт выдачи заказа. */
  PickupPoint = 1,
  /** Постамат. */
  Postamat = 2,
  /** Отделение Почты России. */
  PostOffice = 3,
  /** Терминал. */
  Terminal = 4
}
